export default __webpack_public_path__ + "static/media/hernameishan.f833a9e6.jpeg";